<template>
  <div class="d-flex flex-column fill-height">

    <div
      class="flex-grow-1 d-flex justify-center align-center overflow-hidden"
      v-touch="{ up: spin, down: spin }"
    >
      <div ref="ring" class="ring constrained-width" style="transform: perspective(2000px) rotateX(0deg);">
        <div
          v-for="(item, i) in sideA"
          class="slot" v-bind:style="{ transform: getSlotTransform(i, 0) }"
        >
          <workout-card :item="item" :difficulty="difficulty" :selected="isSelected(item, true)" />
        </div>
        <div
          v-for="(item, i) in sideB"
          class="slot" v-bind:style="{ transform: getSlotTransform(i, 180) }"
        >
          <workout-card :item="item" :difficulty="difficulty" :selected="isSelected(item, false)" />
        </div>
      </div>
    </div>

    <div class="text-center">
      <v-btn x-large rounded color="primary" class="ma-10" :disabled="isSpinning" @click="spin">Spin</v-btn>
      <div class="d-flex justify-center mb-10">
        <v-slider
          class="constrained-width"
          v-model="difficulty"
          :tick-labels="difficultyLabels"
          max="2"
          step="1"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
.constrained-width {
  width: 80%;
  max-width: 300px;
}

.ring {
  height: 200px;
  transform-style: preserve-3d;
  transition: transform 2s ease-out;
}

.slot {
  position: absolute;
  left: 16px;
  right: 16px;
  top: -60px;
  height: 120px;
}
</style>

<script>
import WorkoutCard from '@/components/WorkoutCard.vue';
import shuffle from '@/utils/shuffle.js';
import WORKOUT_ITEMS from '@/workout-items.js';

export default {
  name: 'home',
  components: {
    WorkoutCard
  },
  data() {
    return {
      difficulty: 0,
      difficultyLabels: [ 'Easy', 'Medium', 'Hard' ],
      selected: null,
      sideA: WORKOUT_ITEMS.slice(0, 9),
      sideB: WORKOUT_ITEMS.slice(9, 18),
      angle: 0,
      items: WORKOUT_ITEMS,
      isSpinning: false
    }
  },
  methods: {
    getSlotTransform(i, rotate) {
      return 'translateY(100px) rotateX(' + (((i - 4) * -22.5) - rotate) + 'deg) translateZ(320px)';
    },
    isSelected(item, flipped) {
      return !this.isSpinning && this.items[this.selected] === item;
    },
    spin() {
      if (this.isSpinning) {
        return;
      }
      this.isSpinning = true;

      // Decrement the selection (pick the actual workout) from our shuffled list
      this.selected = !this.selected ? this.items.length - 1 : this.selected - 1;

      // Load up the back side with a bunch of new random choices (just need to make sure they don't match the selected)
      const remaining = this.items.slice(0, this.selected).concat(this.items.slice(this.selected + 1));
      shuffle(remaining);
      const backSide = remaining.slice(0, 9);
      backSide[4] = this.items[this.selected];
      if (this.angle % 360 === 0) {
        this.sideB = backSide;
      } else {
        this.sideA = backSide;
      }

      // The 'angle' keeps growing, but it requires an unreasonably large number of spins before it becomes a problem. Note that we subtract 180 to make sure we flip to the back side.
      this.angle = this.angle - 180 - (-360 * 4);

      // Setting DOM properties directly is a little weird, but the transitions are very fickle. I can only get them to show using 'setTimeout' (the '$nextTick' method is insufficient).
      window.setTimeout(
        () => {
          this.$refs.ring.style['transform'] = 'perspective(2000px) rotateX(' + this.angle + 'deg)';
        }
      );
    },
    onTransitionEnd(e) {
      if (e.target !== this.$refs.ring) {
        return;
      }
      this.isSpinning = false;
    }
  },
  mounted() {
    window.addEventListener('transitionend', this.onTransitionEnd);
    this.$nextTick(this.spin);
  },
  destroyed() {
    window.removeEventListener('transitionend', this.onTransitionEnd);
  }
}
</script>
